module.exports = __webpack_public_path__ + "static/media/esg_schema_en.55516371.svg";